/**
 * Desktop Navigation Bar component
 *
 * Config-driven (US2055174): renders a flat list of resolved top-nav view items.
 * Left section holds the customer items (buyer, inbox, co-buyer, …) with a divider
 * between each; the Share dropdown sits in the right section. Item kinds are
 * dispatched by NavBarItem, so adding/reordering an item is a config change — this
 * component never grows.
 */

import React from 'react';
import type { INavViewItem } from '@makemydeal/dr-sales-checkin-types';

import { StyledNavBar, LeftSection, Divider, RightSection } from './navBar.style';
import NavBarMobileItem from '../NavBarMobileItem/NavBarMobileItem';
import NavBarItem from './NavBarItem';

const NavBar: React.FC<{
    topNavItems: INavViewItem[];
}> = ({ topNavItems }) => {
    const leftItems = topNavItems.filter((item) => item.placement === 'left');
    const rightItems = topNavItems.filter((item) => item.placement === 'right');

    return (
        <StyledNavBar data-testid="header">
            <LeftSection>
                <NavBarMobileItem />
                {leftItems.map((item, index) => (
                    <React.Fragment key={item.key}>
                        {index > 0 && <Divider aria-hidden="true" />}
                        <NavBarItem item={item} />
                    </React.Fragment>
                ))}
            </LeftSection>
            <RightSection>
                {rightItems.map((item) => (
                    <NavBarItem key={item.key} item={item} />
                ))}
            </RightSection>
        </StyledNavBar>
    );
};

export default NavBar;
